import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
@Injectable({
  providedIn: 'root',
})
export class FilterValueStoreService {
  private filterValues: { [page: string]: FormGroup['value'] } = {};

  setFilterValues(page: string, values: FormGroup['value']) {
    this.filterValues[page] = values;
  }

  getFilterValues(page: string): FormGroup['value'] {
    return this.filterValues[page] || null;
  }

  clearFilterValues(page: string) {
    this.filterValues[page] = null;
  }
}
